<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">

                <el-form-item label="采购组织" label-width="80px">
                    <el-select v-model="dataForm.purOrg" filterable placeholder="请选择组织">
                        <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.purchaseOrgCode+'_'+item.purchaseOrgName" :value="item.purchaseOrgCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评价年度" label-width="80px">
                    <el-select v-model="dataForm.year1" clearable placeholder="请选择">
                       <el-option v-for="item in year1List" :key="item.value" :label="item.label" :value="item.value">
                       </el-option>
                    </el-select>
                    至
                    <el-select v-model="dataForm.year2" clearable placeholder="请选择">
                       <el-option v-for="item in year2List" :key="item.value" :label="item.label" :value="item.value">
                       </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年度分类" label-width="80px">
                    <el-cascader v-model="yearTypes" :options="YEAR_TYPE_VALUE" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
                </el-form-item>
                <el-form-item label="状态" label-width="78px">
                    <el-select v-model="dataForm.status" clearable placeholder="请选择">
                        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="fr">
                    <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:0px">查询
                    </el-button>
                    <el-button size="mini" @click="createData()" icon="el-icon-plus">导入</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="tableHeight" @selection-change="selectionChangeHandle"
                  :header-cell-style="{background:'#f5f5f5'}" border>
            <el-table-column align="center" v-model="something" type="selection" width="50">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="50">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <el-table-column prop="purOrg" header-align="center" align="center" label="采购组织代码" min-width="100">
                <template slot-scope="scope">
                    {{ scope.row.purOrg }}
                </template>
            </el-table-column>
            <el-table-column prop="evaYear" header-align="center" align="center" label="评价年度" min-width="60">
                <template slot-scope="scope">
                    {{ scope.row.evaYear }}
                </template>
            </el-table-column>
            <el-table-column prop="evaType" header-align="center" align="center" label="年度分类" min-width="70">
                <template slot-scope="scope">
                    <span v-if="scope.row.evaType=='0'">年度</span>
                    <span v-if="scope.row.evaType=='1'">上半年度</span>
                    <span v-if="scope.row.evaType=='2'">下半年度</span>
                </template>
            </el-table-column>

            <el-table-column prop="desc" header-align="center" align="left" label="绩效评价描述" min-width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.evaType=='0'">{{ scope.row.evaYear }}年度供应商绩效评价汇总表</span>
                    <span v-if="scope.row.evaType=='1'">{{ scope.row.evaYear }}上半年度供应商绩效评价汇总表</span>
                    <span v-if="scope.row.evaType=='2'">{{ scope.row.evaYear }}下半年度供应商绩效评价汇总表</span>
                </template>
            </el-table-column>
            <el-table-column prop="status" header-align="center" align="center" label="状态" min-width="65">
                <template slot-scope="scope">
                    <span v-if="scope.row.status=='0'">新建</span>
                    <span v-if="scope.row.status=='1'">已发布</span>
                </template>
            </el-table-column>
            <el-table-column prop="updatedName" header-align="center" align="center" label="更新人" min-width="100" >
                <template slot-scope="scope">
                    {{ scope.row.updatedName }}
                </template>
            </el-table-column>
            <el-table-column prop="updateTimeStr" header-align="center" align="center" label="更新日期" min-width="160" >
                <template slot-scope="scope">
                    {{ scope.row.updateTimeStr }}
                </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作" width="250px">
                <template slot-scope="{row}">
                    <el-button type="text" size="small" @click="viewHandle(row)" >查看</el-button>
                    <el-button :disabled="row.status == 1" type="text" size="small" @click="publishHandle(row)" >发布</el-button>
                    <el-button :disabled="row.status == 0" type="text" size="small" @click="cancelPublishHandle(row)" >取消发布</el-button>
                    <el-button :disabled="row.status == 1" type="text" size="small" @click="deleteHandle(row)" class="button-danger" icon="el-icon-delete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>
        <!-- 弹窗 供应商 查看 / 新增 / 修改 -->
        <el-dialog title="供应商绩效-导入" width="40%" :visible.sync="dialogVisible" :rules="dataRule" @close='closeDialog'>
            <el-form :model="dataForm1" :rules="dataRule" ref="dataForm1" @keyup.enter.native="dataFormSubmit()"
                     label-width="80px" class="tenant-dialog-form">
                <el-form-item label="采购组织" prop="purOrg">
                    <el-select v-model="dataForm1.purOrg" filterable placeholder="请选择组织">
                        <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.purchaseOrgCode+'_'+item.purchaseOrgName" :value="item.purchaseOrgCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评价年度" prop="evaYear">
                    <el-select v-model="dataForm1.evaYear" clearable placeholder="请选择">
                       <el-option v-for="item in year1List" :key="item.value" :label="item.label" :value="item.value">
                       </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年度分类" prop="evaType">
                    <el-select v-model="dataForm1.evaType" clearable placeholder="请选择">
                       <el-option v-for="item in YEAR_TYPE_VALUE" :key="item.value" :label="item.label" :value="item.value">
                       </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="导入模板" prop="file">
                    <el-upload
                            ref="upload"
                            :auto-upload="false"
                            drag
                            action
                            :http-request="upload"
                            :limit="1"
                            accept=".xls"
                            :on-change="fileChange"
                            :on-remove="fileRemove"
                            multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div cla3ss="el-upload__tip" slot="tip">只能上传xls文件，且不超过500kb</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="exportTemplate()">
                    <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;导出模板
                </el-button>
                <el-button size="small" @click="dialogVisible = false">取消
                </el-button>
                <el-button size="small" type="primary" @click="dataFormSubmit()">确定
                </el-button>
            </span>
        </el-dialog>
        <!-- 弹窗, 查看详细信息 -->
        <supplier-eva-view v-if="viewVisible" ref="viewDetail" ></supplier-eva-view>
        <error-message v-if="errorMessageVisible" ref="errorMessage"></error-message>
    </div>
</template>
<script>
import {
    listSupplierEva,exportTemplate,importSupplierEva,publishSupplierEva,
    cancelPublishSupplierEva,deleteSupplierEva,getSupplierEva
} from '@/controller/supplier'
import {
    getPurchaseOrgList
} from '@/controller/systemData'
import {
    YEAR_TYPE_VALUE
} from "@/utils/const";
import supplierEvaView from "./supplier-eva-view";
import ErrorMessage from './error-message'
    export default {
        data() {
            return {
                submitLoading:false,
                dialogVisible: false,
                dataForm: {
                    key: '',
                    year1: new Date().getFullYear(),
                    yearTypes: [],

                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                options1: [{
                        value: '0',
                        label: '新建'
                    }, {
                        value: '1',
                        label: '已发布'
                    }
                ],
                dataForm1: {
                    id: 0,
                    purOrg: '',
                    evaYear: '',
                    evaType: '',
                    name: '',
                    fileList:[],
                    file: null
                },
                dataRule: {
                    purOrg: [{
                        required: true,
                        message: '采购组织不能为空',
                        trigger: 'blur'
                    }],
                    evaYear: [{
                        required: true,
                        message: '评价年度不能为空',
                        trigger: 'blur'
                    }],
                    evaType: [{
                        required: true,
                        message: '年度分类不能为空',
                        trigger: 'blur'
                    }],
                    file: [{
                        required: true,
                        message: '导入模板不能为空',
                        trigger: 'change'
                    }],
                },
                purchaseOrgList: [],
                yearTypes: [

                ],
                YEAR_TYPE_VALUE: YEAR_TYPE_VALUE,
                year1List: [],
                year2List: [],
                viewVisible: false,
            }
        },
        computed: {
            tableHeight: {
                get() {
                    return this.$store.state.common.documentClientHeight - 260
                }
            }
        },
        components: {
            supplierEvaView,
            ErrorMessage
        },
        activated() {
            this.getDataList()
        },
        created() {
            this.getYearList()
            // 采购组织
            this.getPurchaseOrgList()
        },
        methods: {

            fileChange(uploadFile,fileList) {
                this.dataForm1.file = uploadFile
                if(fileList.length !== 0) {
                    this.$refs.dataForm1.validateField('file')
                }
            },
            fileRemove(uploadFile,fileList) {
                if(fileList.length === 0) {
                    this.dataForm1.file = null
                    this.$refs.dataForm1.validateField('file')
                }
            },
            dateFormat: function (row, column) {
              var date = row[column.property]
              if (!date) {
                  return ''
              }
              return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },
        
            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                var pYear1 = this.dataForm.year1
                var pYear2 = this.dataForm.year2
                if(pYear1 > pYear2) {
                    this.$message.warning("评价年度1不能大于评价年度2！")
                    return
                }
                this.dataListLoading = true
                this.dataForm.yearTypes = []
                this.yearTypes.forEach(yearType => {
                    this.dataForm.yearTypes.push(yearType[0])
                })
                listSupplierEva({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'purOrg': this.dataForm.purOrg,
                    'evaYear1': this.dataForm.year1,
                    'evaYear2': this.dataForm.year2,
                    'status': this.dataForm.status,
                    'evaTypes': this.dataForm.yearTypes,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total

                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm1'].validate((valid) => {
                    if (valid) {
                        this.$refs.upload.submit();
                    }
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                console.log(val)
                this.dataListSelections = val
            },
            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },
            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },
            //查看
            viewHandle(row) {
                this.viewVisible = true
                this.$nextTick(() => {
                    this.$refs.viewDetail.init(row);
                })
            },
            //发布
            publishHandle(row) {
                publishSupplierEva({
                    id: row.id
                }).then(data => {
                    if (data && data.code === '00') {
                        this.getDataList()
                    }
                });
            },
            //取消发布
            cancelPublishHandle(row) {
                cancelPublishSupplierEva({
                    id: row.id
                }).then(data => {
                    if (data && data.code === '00') {
                        this.getDataList()
                    }
                });
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteSupplierEva({
                        id: row.id
                    }).then(data => {
                        if (data && data.code === '00') {
                            this.getDataList()
                        }
                    });
                })
            },
            // 新增
            createData() {
                this.dialogVisible = true
                this.dataForm1.purOrg = ''
                this.dataForm1.evaYear = ''
                this.dataForm1.evaType = ''
                this.dataForm1.file = null
                this.dataForm1.fileList = []
            },
            // 下拉输入采购组织
            getPurchaseOrgList() {
                getPurchaseOrgList({
                    purchaseOrgCode: "",
                    purchaseOrgName: "",
                }).then(data => {
                    if (data && data.code === '00') {
                        this.purchaseOrgList = data.body;
                    }
                });
            },
            //获得评价年度
            getYearList() {
                var date = new Date();
                var year = date.getFullYear()
                for(var i = 2020; i <= year; i++) {
                    var obj = {"value" : i, "label" : i}
                    this.year1List.push(obj);
                    this.year2List.push(obj);
                }
            },
            // 导出模板
            exportTemplate() {
                exportTemplate().then((data) => {
                    this.readAsBinaryString(data.body)
                })
            },
            readAsBinaryString(data) {
                // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
                // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
                let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
                dom.style.display = 'none';
                dom.href = url;
                dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
                document.body.appendChild(dom);
                dom.click();
            },
            str2Blob(str, mime) {
                var arr = str.split(',')
                var bstr = atob(arr[0]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            },
            upload(obj) {
                let formData = new FormData()
                formData.set('file', obj.file)
                formData.set('purOrg', this.dataForm1.purOrg)
                formData.set('evaYear', this.dataForm1.evaYear)
                formData.set('evaType', this.dataForm1.evaType)
                debugger
                //需要先判断所选数据是否已经存在供应商绩效评价数据
                getSupplierEva({
                    'purOrg': this.dataForm1.purOrg,
                    'evaYear': this.dataForm1.evaYear,
                    'evaType': this.dataForm1.evaType,
                }).then(data => {
                    if (data && data.code === '00') {
                        importSupplierEva(formData).then((data) => {
                            if(data.code === '00'){
                                this.$refs.upload.clearFiles()
                                this.$message.success({
                                  message: '导入成功',
                                  type: 'success',
                                  duration: 1500,
                                  onClose: () => {
                                      this.dialogVisible = false
                                      this.getDataList()
                                  }
                                })
                            } else {
                                this.dialogVisible = false
                                // this.$message.error(data.msg);
                                this.errorMessageVisible = true
                                this.$nextTick(() => {
                                    this.$refs.errorMessage.init(data.msg)
                                })
                            }
                        }).catch((e) => {
                            this.dialogVisible = false
                            //this.$message.error(e);
                        })
                    } else {
                        this.dialogVisible = false
                        this.$message.error(data.msg);
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })

            },
        }
    }
</script>

<style lang="scss">
    .fr { float: right; }

    .button-danger { color: #F56C6C; }
</style>